import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import store, { RootState, AppDispatch } from '../store';

// https://redux.js.org/tutorials/typescript-quick-start#define-typed-hooks
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
